import { AvField, AvForm } from "availity-reactstrap-validation";
import { withNamespaces } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import * as datePickerLocales from "date-fns/locale";
import { INTERNATIONAL_DATE_FORMAT } from "src/components/constants";
import { useEffect, useState } from "react";
import ButtonsGroup from "../ButtonsGroup";

const InProcess = ({ lng, t, onValidSubmit, onBackClicked, prevData }) => {
    const [ expectedDdsDate, setExpectedDdsDate ] = useState(null);

    useEffect(() => {
        if(prevData?.expectedDdsDate) {
            setExpectedDdsDate(new Date(prevData?.expectedDdsDate));
        }
    }, [ prevData ])

    return (
        <AvForm 
            onValidSubmit={(_e, values) => {
                onValidSubmit(values)
            }} 
            className="needs-validation"
        >
            <Row>
                <Col sm='12' md='6'>
                    <Label for="expectedDdsDate">
                        {t('Expected Completion Date')} <span className="text-danger">*</span>
                    </Label>
                    <DatePicker
                        locale={datePickerLocales[lng]}
                        name="expectedDdsDate"
                        id="expectedDdsDate"
                        className="form-control"
                        selected={expectedDdsDate}
                        showTimeSelect={false}
                        minDate={new Date()}
                        dateFormat={INTERNATIONAL_DATE_FORMAT}
                        onChange={(date) => {
                            setExpectedDdsDate(date)
                        }}
                    /> 

                    <AvField
                        name="expectedDdsDate"
                        type="hidden"
                        errorMessage={t("This field cannot be blank")}
                        className="form-control"
                        validate={{
                            required: { value: true }
                        }}
                        value={expectedDdsDate}
                    />
                </Col>
            </Row>

            <ButtonsGroup
                onBackClicked={onBackClicked}
                onNextClicked={() => { }}
                nextButtonType='submit'
            />
        </AvForm>
    )
};

export default withNamespaces()(
    InProcess
);